import React from 'react'
import Dropdown, {
    MenuItem,
} from '@trendmicro/react-dropdown'
import '!style-loader!css-loader!./dropdown.css'
import { select } from 'redux-saga/effects'


const NestedDropdown = ({
    selectedView,
    source,
    onChange
    }) => {
    let title = ''
    if (selectedView === '') {
        title = 'Custom Views'
    } else {
        title = source.find(source => source.value === selectedView).label
    }

    return (
        <Dropdown onSelect={eventKey => onChange(eventKey)}>
            <Dropdown.Toggle btnStyle='flat' title={title} />
            <Dropdown.Menu>
                <MenuItem header>Custom Views</MenuItem>
                {source.map((view, idx) => {
                    return(
                        <MenuItem
                            key={idx}
                            eventKey={view.value}
                            active={selectedView === view.value}
                            >
                            {view.label}
                        </MenuItem>
                    )
                })}
            </Dropdown.Menu>
        </Dropdown> 
    )
}

export default NestedDropdown